import { FC } from 'react';

import TrpLayout from '@/components/trp/TrpLayout';
import TrpSuccessContent from '@/components/trp/TrpSuccessContent';

interface Props {
  outStatCd: string;
}
type TrpSuccessPageProps = Props;

const TrpSuccessPage: FC<TrpSuccessPageProps> = (props) => {
  return (
    <TrpLayout>
      <TrpSuccessContent outStatCd={props.outStatCd} />
    </TrpLayout>
  );
};

export const getServerSideProps = async (context: any) => {
  const { req } = context;
  let parsedBody: any = { outStatCd: '' };
  if (req.method === 'POST') {
    let body = '';
    // Stream the request body data
    await new Promise((resolve: (value: unknown) => void) => {
      req.on('data', (chunk: string) => {
        body += chunk;
      });
      req.on('end', () => {
        resolve(undefined);
      });
    });

    const contentType = (req.headers['content-type'] as string | undefined) || '';
    try {
      if (contentType.includes('application/json')) {
        parsedBody = JSON.parse(body);
      } else {
        parsedBody = Object.fromEntries(new URLSearchParams(body));
      }
    } catch (_) {
      parsedBody = { outStatCd: '' };
    }
  }

  return {
    props: {
      outStatCd: parsedBody.outStatCd ?? ''
    }
  };
};

export default TrpSuccessPage;
